const services = [
  {
    title: 'Concrete Pumping',
    icon: 'ri-truck-line',
    description: 'Efficient pouring for foundations, slabs, walls, pools, driveways, and more using advanced equipment.',
    features: [
      'Foundation and slab pours',
      'Residential and commercial projects',
      'Pool deck installations',
      'Driveway and parking lot construction',
      'High-rise building concrete delivery',
      'Precision equipment for tight spaces',
    ],
    image: 'https://public.readdy.ai/ai/img_res/d3913cfedd800ef4acdca331e2ebf7a0.jpg',
    link: '/services/concrete-pumping',
  },
  {
    title: 'Stone Services',
    icon: 'ri-stack-line',
    description: 'Installation of stone for landscaping, retaining walls, patios, and decorative elements.',
    features: [
      'Retaining wall construction',
      'Stone patio and walkway installation',
      'Decorative stone landscaping',
      'Natural stone veneer application',
      'Stone steps and entryways',
      'Custom stone design work',
    ],
    image: 'https://readdy.ai/api/search-image?query=beautiful%20stone%20retaining%20wall%20installation%20natural%20gray%20stone%20professional%20masonry%20work%20landscaping%20simple%20clean%20background&width=800&height=600&seq=service-stone&orientation=landscape',
    link: '/services/stone-services',
  },
  {
    title: 'Block Filling',
    icon: 'ri-layout-masonry-line',
    description: 'Professional block filling services for structural integrity and durability.',
    features: [
      'Concrete block wall filling',
      'Structural reinforcement',
      'Foundation block work',
      'Commercial building applications',
      'Residential construction support',
      'Quality assurance testing',
    ],
    image: 'https://readdy.ai/api/search-image?query=concrete%20block%20wall%20construction%20filling%20work%20professional%20masonry%20structural%20building%20simple%20clean%20background&width=800&height=600&seq=service-block&orientation=landscape',
    link: '/services/block-filling',
  },
  {
    title: 'Custom Masonry',
    icon: 'ri-tools-line',
    description: 'Tailored masonry solutions for unique project requirements and specifications.',
    features: [
      'Custom design consultation',
      'Specialty concrete finishes',
      'Decorative masonry work',
      'Repair and restoration services',
      'Grading partnerships',
      'Project management support',
    ],
    image: 'https://readdy.ai/api/search-image?query=custom%20masonry%20work%20decorative%20concrete%20finish%20professional%20craftsmanship%20construction%20detail%20simple%20clean%20background&width=800&height=600&seq=service-masonry&orientation=landscape',
    link: '/services/custom-masonry',
  },
];

const ServicesList = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="space-y-20">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="w-20 h-20 bg-yellow-500 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-5xl text-black`}></i>
                </div>

                <h2 className="text-4xl font-bold text-black mb-4">{service.title}</h2>

                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                  {service.description}
                </p>

                <div className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-yellow-500 text-xl mt-1 flex-shrink-0"></i>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <a
                  href={service.link}
                  className="inline-block bg-yellow-500 text-black px-8 py-4 rounded-lg font-bold hover:bg-yellow-400 transition-all cursor-pointer whitespace-nowrap"
                >
                  {service.link.startsWith('/') ? 'LEARN MORE' : 'GET A QUOTE'}
                </a>
              </div>

              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-yellow-500">
                  <div className="w-full h-96">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesList;
